// extracted by mini-css-extract-plugin
export default {"btnPayment":"CustomRadio_btnPayment__9VhxL","btnPaymentChecked":"CustomRadio_btnPaymentChecked__iLd99"};